import React from 'react';

import { components } from 'react-select';

import { Icon } from '../icons';

export const ClearIndicator = (props) => (
  <components.ClearIndicator {...props}>
    <Icon width="14px" height="14px" name="close" />
  </components.ClearIndicator>
);
